import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import servicioCambiosCic from "../../../../servicios/servicioCambiosCic";
import { Notificar } from "../../../Comunes/Notificador";

function AprobarSolicitudModal({ solicitud, regresarAListaSolicitudes }) {
  const [show, setShow] = useState(false);
  const [comentario, setComentario] = useState("");

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const parametro = {
      solicitud: solicitud,
      comentario: comentario,
    };

    const resultado = await servicioCambiosCic.aprobarSolicitudCambio(
      parametro
    );

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    handleClose();
    regresarAListaSolicitudes({
      solicitud: resultado.solicitud,
    });
    Notificar("success", resultado.mensaje);
  };

  return (
    <>
      <button
        className="btn btn-success btn-icon-split mr-3"
        onClick={handleShow}
      >
        <span className="icon text-white-50">
          <i className="far fa-check-circle"></i>
        </span>
        <span className="text">Aprobar</span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Aprobar Solicitud</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group controlId="comentario">
              <Form.Label>
                Comentario <span className="small text-muted">(opcional)</span>
              </Form.Label>
              <Form.Control
                name="comentario"
                as="textarea"
                rows={3}
                maxLength="999"
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default AprobarSolicitudModal;
